import React, { ComponentType, HTMLProps } from 'react';
import { styled } from '@mui/material';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import { HintedIcon } from '@/components';

type OpaqueElementProps = {
  opaque: boolean
}

const CheckboxLabel = styled(({ opaque, ...props }: HTMLProps<HTMLSpanElement> & OpaqueElementProps)=><span {...props}/>)(({ opaque }: { opaque :boolean }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  color: opaque ? '#6B778C' : '#091E42',
  padding: '0 0 0 5px',
  lineHeight: '1em',
}));

const CustomFormControlLabel: ComponentType<FormControlLabelProps> = styled(FormControlLabel)({
  margin: 0,
  '& .MuiFormControlLabel-label': {
    cursor: 'pointer',
  }
});

const CustomCheckbox: ComponentType<CheckboxProps & { ['checked-color']?: string }> = styled(Checkbox)(
  ({ disabled, ...props }: CheckboxProps & { ['checked-color']?: string }) => ({
    padding: 0,
    '& .MuiSvgIcon-root': {
      fontSize: '24px',
      fill: disabled ? '#C1C7D0' : '#091E42',
    },
    '&.Mui-checked .MuiSvgIcon-root': {
      fill: (disabled ? '#C1C7D0' : (props['checked-color'] || '#091E42')),
    }
  })
);

type Props = Omit<FormControlLabelProps, 'control'> & {
  label: string,
  hint?: string,
  checked?: boolean,
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void,
  disabled?: boolean,
  checkedColor?: string,
};

export  default ({ label, hint, checked, onChange, disabled = false, checkedColor, ...props }: Props) => {
  return (
    <CustomFormControlLabel
      {...props}
      disabled={disabled}
      label={
        <CheckboxLabel opaque={disabled}>
          {label}
          {hint && <HintedIcon>{hint}</HintedIcon>}
        </CheckboxLabel>}
      control={
        <CustomCheckbox
          checked={checked}
          onChange={onChange}
          checked-color={checkedColor}
        />
      }
    />
  );
}